<template>
  <v-app id="root">
    <div v-if="!isMobile">
      <v-img id="not-mobile-splash" :src="redirectBackground"></v-img>
    </div>

    <div v-if="isMobile">
      <!-- <transition v-on:leave="introLeave">
      <v-img id="intro-container" v-show="intro && ((!serviceWorkerAvailable) || (serviceWorkerAvailable && contentCached))" :src="creditsSplash" height="100%">
        <v-snackbar absolute auto-height top color="black" :value="true" :timeout="0">
          <v-layout column>
              <v-flex d-flex justify-middle align-center>
                <v-progress-linear color="red" indeterminate></v-progress-linear>
              </v-flex>

           </v-layout>
        </v-snackbar>
      </v-img>
      </transition>-->
      <v-dialog
        :value="openAlert && !deviceMatchBrowser /*&& !intro*/"
        attach="#root"
        fullscreen
      >
        <v-card color="black" class="pa-3">
          <v-card color="rgba(0, 0, 0, 0.9)" class="pa-3">
            <v-flex d-flex text-xs-center>
              <p class="mt-1 display-1 bebas white--text">
                IMPORTANT!
                <br />NOTE TO USER
              </p>
            </v-flex>
            <v-container pa-0 text-xs-center fill-height>
              <v-flex d-flex text-xs-center>
                <p class="mt-4 subheading prestige white--text">
                  For the best application performance we suggest using
                  {{ suggestedBrowser }} as your browser. Please close out of
                  the application in this browser and copy the Fooddoneit
                  Application URL into the {{ suggestedBrowser }} browser bar.
                  <br />
                  <br />Have a great Time!
                </p>
              </v-flex>
            </v-container>
          </v-card>
          <v-card-actions>
            <v-btn
              class="button-border-beige"
              flat
              block
              color="#D6B682"
              @click="closeBrowser"
              >OKay</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              class="button-border-beige"
              flat
              block
              color="#D6B682"
              @click="ignoreMessage"
              >I don't Care</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <onboarding v-if="/*!intro && */ !standalone" :open="onboardingDialog" />
      <div v-if="true /*!intro*/">
        <router-view v-if="!isTablet" />
        <!-- <router-view v-if="!isTablet && (!isIphone || standalone)" /> -->
        <!-- <div id="root-with-iphone" v-if="isIphone && !standalone" :class="lowerHeightClass">
        <router-view />
        </div>-->
        <div id="root-with-tablet" v-if="isTablet">
          <router-view />
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { setTimeout } from "timers";
import Velocity from "velocity-animate";
import fdiLogoSrc from "@/assets/logo_credit_wht.png";
import dmgLogoSrc from "@/assets/branding/DMG_logo.png";
import dmgWebsite from "@/assets/branding/DMG_website.png";
import redirectBackground from "@/assets/redirectscreenshot.png";
import creditsSplash from "@/assets/branding/credits.png";
import onboardingComponent from "@/components/newOnboarding.vue";

export default {
  name: "Root",
  components: {
    onboarding: onboardingComponent,
  },
  data() {
    return {
      isTablet: false,
      redirectBackground,
      creditsSplash,
      windowSize: {
        y: this.$store.getters.appInnerHeight,
        x: this.$store.getters.appInnerWidth,
      },
      appOpen: false,
      dmgLogoSrc,
      fdiLogoSrc,
      dmgWebsite: dmgWebsite,
      lowerHeightClass: {
        height: window.innerHeight - 50 + "px",
      },
      deviceMatchMessage: ``,
      openAlert: true,
    };
  },
  computed: {
    suggestedBrowser() {
      return this.$store.getters.suggestedBrowser;
    },
    deviceMatchBrowser() {
      return this.$store.getters.deviceMatchBrowser;
    },
    onboardingDialog() {
      return this.$store.getters.onboarding;
    },
    currentUser() {
      return this.$store.getters.localUser;
    },
    intro() {
      return !this.$store.getters.introFinished;
    },
    isIphone() {
      return this.$store.getters.isIphone;
    },
    isMobile() {
      return this.mobileAny();
    },
    serviceWorkerAvailable() {
      return this.$store.serviceWorkerAvailable;
    },
    standalone() {
      return this.$store.getters.standalone;
    },
    contentCached() {
      return this.$store.getters.contentCached;
    },
  },
  mounted() {
    //this.standalone = this.isInStandaloneMode();
    console.log("change");
  },
  methods: {
    ignoreMessage() {
      this.openAlert = false;
    },
    closeBrowser() {
      window.close();
    },
    Android() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    mobileAny: function() {
      return (
        this.Android() ||
        this.BlackBerry() ||
        this.iOS() ||
        this.Opera() ||
        this.Windows()
      );
    },
    isInStandaloneMode() {
      return "standalone" in window.navigator && window.navigator.standalone;
    },
    getWindowSize() {
      let windowSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      this.$store.dispatch("setWindowSize", windowSize);
    },
    isViewportTablet() {
      this.isTablet = window.innerWidth > 600 && window.innerWidth < 1025;
    },
    sthsSetup() {
      let deferredPrompt;
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        deferredPrompt = e;
      });
    },
    startIntroCountdown() {
      setTimeout(() => {
        this.appOpen = true;
        this.$store.dispatch("setIntro", true);
      }, 6000);
    },
    afterEnter(el, done) {
      Velocity(
        el,
        {
          opacity: 0,
          display: "none",
        },
        {
          duration: 1000,
        },
        {
          complete: done,
        }
      );
    },
    introLeave(el, done) {
      Velocity(
        el,
        {
          opacity: 0,
        },
        {
          duration: 2000,
        }
      ).then((el) => {
        Velocity(
          el,
          {
            display: "none",
          },
          {
            complete: (el) => {
              el[0].remove();
            },
          }
        );
      });
    },

    beforeFDILogoEnter(el) {
      el.style.opacity = 0;
      el.style.height = 0;
      el.style.width = 0;
    },
    FDILogoEnter(el, done) {
      Velocity(
        el,
        {
          opacity: 1,
          height: "350px",
          width: "350px",
        },
        {
          duration: "600",
        }
      );
      Velocity(
        el,
        {
          height: "200px",
          width: "200px",
        },
        {
          duration: "400",
        },
        {
          complete: done(),
        }
      );
    },
    appEnter(el, done) {
      Velocity(
        el,
        {
          opacity: 1,
        },
        {
          duration: 800,
        }
      );
      Velocity(
        el,
        {
          translateX: "1000px",
        },
        {
          duration: 400,
        },
        {
          complete: done(),
        }
      );
    },
  },
  async created() {
    this.sthsSetup();
    this.getWindowSize();
    this.isViewportTablet();
  },
};
</script>

<style>
#not-mobile-splash {
  margin: auto auto;
}

.fw {
  width: 100%;
}

.bebas {
  font-family: "BebasNeue-Regular" !important;
}

.prestige {
  font-family: "PrestigeElite-STD" !important;
}

#root {
  font-family: "BebasNeue-Regular";
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: black;
}

#root-with-tablet {
  height: 100%;
  width: 60vw;
  max-width: 600px;
  margin: auto auto;
}

.fdi-red--text {
  color: #ae250a;
}

.fdi-red {
  background-color: #ae250a;
}
</style>
